import { Route, Routes } from 'react-router-dom'
import About from './components/Content/About'
import Contact from './components/Content/Contact'
// import Paytea from './components/Content/Projects/paytea'
import IntroPages from './components/IntroPages/Index'
import Tayara from './components/Content/Projects/tayara'
import Paytea from './components/Content/Projects/paytea'
import Almaviva from './components/Content/Projects/almaviva'
import Biat from './components/Content/Projects/biat'
import Fondation from './components/Content/Projects/fondation'
import Atelier from './components/Content/Projects/atelier'
import Freshfxdashboard from './components/Content/Projects/freshfx'
import MyWorks from './components/Content/Projects/projects'
import Ooredoo from './components/Content/Projects/ooredoo'

function App() {
  // useEffect(() => {
  //   const disableInspect = (e) => {
  //     // Disable right-click
  //     if (e.type === 'contextmenu') {
  //       e.preventDefault()
  //     }

  //     // Disable F12, Ctrl+Shift+I, and Ctrl+Shift+C
  //     if (
  //       e.keyCode === 123 || // F12
  //       (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
  //       (e.ctrlKey && e.shiftKey && e.keyCode === 67)
  //     ) {
  //       // Ctrl+Shift+C
  //       e.preventDefault()
  //     }
  //   }

  //   // Add event listeners for context menu and keydown
  //   document.addEventListener('contextmenu', disableInspect)
  //   document.addEventListener('keydown', disableInspect)

  //   // Cleanup the event listeners on unmount
  //   return () => {
  //     document.removeEventListener('contextmenu', disableInspect)
  //     document.removeEventListener('keydown', disableInspect)
  //   }
  // }, [])
  // const comp = useRef(null)
  // const [showIntro, setShowIntro] = useState(true)

  // useLayoutEffect(() => {
  //   let ctx = gsap.context(() => {
  //     const t1 = gsap.timeline({
  //       onComplete: () => setShowIntro(false), // Remove the intro section after animation
  //     })

  //     t1.from('#intro-slider', {
  //       xPercent: '-100',
  //       duration: 1.3,
  //       delay: 0.3,
  //     })
  //       .from(['#title-1', '#title-2', '#title-3'], {
  //         opacity: 0,
  //         y: '+=30',
  //         stagger: 0.5,
  //       })
  //       .to(['#title-1', '#title-2', '#title-3'], {
  //         opacity: 0,
  //         y: '-=30',
  //         delay: 0.3,
  //         stagger: 0.5,
  //       })
  //       .to('#intro-slider', {
  //         xPercent: '-100',
  //         duration: 1.3,
  //       })
  //       .from('#welcome', {
  //         opacity: 0,
  //         duration: 0.5,
  //       })
  //   }, comp)

  //   return () => ctx.revert()
  // }, [])
  return (
    <>
      {/* {showIntro ? (
        <div ref={comp}>
          <div id="intro-slider">
            <h1 id="title-1">Frontend Engineer</h1>
            <h1 id="title-2">Designer</h1>
            <h1 id="title-3">Freelancer</h1>
          </div>
          <div className="welcome-section">
            <h1 id="welcome">Welcome.</h1>
          </div>
        </div>
      ) : ( */}
      <>
        <Routes>
          <Route path="/" element={<IntroPages />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Ooredoo" element={<Ooredoo />} />
          <Route path="/tayara" element={<Tayara />} />
          <Route path="/paytea" element={<Paytea />} />
          <Route path="/fondation" element={<Fondation />} />
          <Route path="/almaviva" element={<Almaviva />} />
          <Route path="/atelier" element={<Atelier />} />
          <Route path="/biat" element={<Biat />} />
          <Route path="/freshFxDashboard" element={<Freshfxdashboard />} />
          <Route path="/works" element={<MyWorks />} />
        </Routes>
      </>
      {/* )} */}
    </>
  )
}

export default App
